import {
  IconBoxMultiple,
  IconBuildingCottage,
  IconFileTextSpark,
  IconLayoutGrid,
  IconScan,
  IconTools,
} from '@tabler/icons-react'
import { TopLevelLinkProps } from '@shared/components/app-shell/main-menu/main-menu'
import { routes } from '@/routing/routes'

export const MAIN_MENU_LINKS: Array<TopLevelLinkProps> = [
  {
    label: 'Dashboard',
    href: routes.home.path,
    icon: <IconLayoutGrid />,
  },
  {
    label: 'Stations',
    href: routes.stationSearch.path,
    icon: <IconBuildingCottage />,
  },
  {
    label: 'Offers',
    href: routes.offers.path,
    icon: <IconFileTextSpark />,
  },
  {
    label: 'Wool Store Tools',
    href: routes.woolStoreTools.path,
    icon: <IconTools />,
  },
  {
    label: 'Typing',
    href: routes.typingProgram.path,
    icon: <IconScan />,
  },
  {
    label: 'Typed Lots',
    href: routes.typedLots.path,
    icon: <IconBoxMultiple />,
  },
]
